import { HelpParseKeyValueString2 } from "helpers/HelpParseKeyValueString";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const GWPagosAvatar = () => {
  const estiloCentrado = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [urls, setUrls] = useState({
    urlDone: "",
    urlPending: "",
    urlAborted: "",
    urlFailed: "",
  });
  const [allParams, setAllParams] = useState({});
  useEffect(() => {
    if (searchParams) {
      console.log("locationdiego: ", location.search);

      const { callback_url, tran_id, return_url, ...rest } = HelpParseKeyValueString2(
        location.search
      );
      console.log("callback_url: ", callback_url);
      console.log("return_url: ", return_url);
      let allParams = {};
      if (callback_url && tran_id && return_url) {
        allParams = { callback_url, tran_id, return_url, ...rest };
      }
      setAllParams(allParams);
      const urlsList = ["DONE", "PENDING", "ABORTED", "FAILED"];
      // Array para almacenar las URLs generadas
      const generatedUrls = [];

      urlsList.forEach((url, index) => {
        if (url === "DONE") generatedUrls.urlDone = return_url;
        else if (url === "PENDING") generatedUrls.urlPending = return_url;
        else if (url === "ABORTED") generatedUrls.urlAborted = return_url;
        else if (url === "FAILED") generatedUrls.urlFailed = return_url;
      });

      setUrls(generatedUrls);
    }
  }, []);

  const handleButtonClickPost = (url) => {
    if (url) {
      redirectPost(url);
    }
  };

  function redirectPost(url) {
    const urlParsed = new URL(url);

    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    urlParsed.searchParams.forEach((value, key) => {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = value;
      form.appendChild(hiddenField);
    });

    document.body.appendChild(form);
    form.submit();
  };

  const handleButtonClickGet = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <div className="container" style={estiloCentrado}>
      <div className="Contenido-GWavatar">
        <h2>GW Pagos Avatar</h2>
        <div className="Contenido-Body">
          <ol className="lista-body">
            {Object.entries(allParams).length > 0 ? (
              Object.entries(allParams).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong> {value}
                </li>
              ))
            ) : (
              <li>No se encontró parametros</li>
            )}
          </ol>
        </div>

        <div className="contenido-botones">

          <button
            className="dimension-botones"
            onClick={() => handleButtonClickPost(urls.urlDone)}
            style={{ backgroundColor: "#28a745" }}
          >
            DONE POST
          </button>
          <button
            className="dimension-botones"
            onClick={() => handleButtonClickGet(urls.urlDone)}
            style={{ backgroundColor: "#28a745" }}
          >
            DONE GET
          </button>
          <button
            className="dimension-botones"
            onClick={() => handleButtonClickGet(urls.urlPending)}
            style={{ backgroundColor: "#ffc107" }}
          >
            PENDING
          </button>
          <button
            className="dimension-botones"
            onClick={() => handleButtonClickGet(urls.urlAborted)}
            style={{ backgroundColor: "#fd7e14" }}
          >
            ABORTED
          </button>
          <button
            className="dimension-botones"
            onClick={() => handleButtonClickGet(urls.urlFailed)}
            style={{ backgroundColor: "#dc3545" }}
          >
            FAILED
          </button>
        </div>
      </div>
    </div>
  );
};
export default GWPagosAvatar;
